import { capitalizeFirstLetter } from './strings';

export const markdownListFromArray = (input: Array<string>): string => {
  const lookupList = input.map(item => capitalizeFirstLetter(item));
  const mdLinebreakList = `* ${lookupList.join('\n* ')}`;
  return mdLinebreakList;
};
